import {Component, Input, OnInit} from '@angular/core';
import {StoredFile, StoredFileService, SubscriptionFile, SubscriptionFileService} from '@lifeislife/lifeislife-domain';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {debounceTime, publishReplay, refCount, switchMap, tap} from 'rxjs/operators';

@Component({
  selector: 'cf-subscription-document-list-item',
  templateUrl: './subscription-document-list-item.component.html',
  styleUrls: ['./subscription-document-list-item.component.scss'],
})
export class SubscriptionDocumentListItemComponent implements OnInit {

  @Input()
  set subscriptionFile(value: SubscriptionFile) {
    this.subscriptionFileSource$.next(value);
  }

  subscriptionFileSource$ = new BehaviorSubject<SubscriptionFile>(null);
  loadingFile$ = new BehaviorSubject<boolean>(false);

  file$: Observable<StoredFile>;

  constructor(
    private subscriptionFileService: SubscriptionFileService,
  ) {
  }

  ngOnInit(): void {
    this.file$ = this.subscriptionFileSource$.pipe(
      debounceTime(200),
      switchMap(v => this.loadFile$(v)),
      publishReplay(1), refCount(),
    );

  }

  private loadFile$(v: SubscriptionFile) {
    if (v == null) {
      return of(null);
    } else {
      this.loadingFile$.next(true);
      return this.subscriptionFileService.getStoredFile$(v).pipe(
        tap(() => this.loadingFile$.next(false)),
      );
    }
  }
}
